import { usePlanCatalogFromContext } from "../context/CoachBillingContext.jsx";

export function usePlanCatalog(opts = {}) {
  const { audience } = opts;
  return usePlanCatalogFromContext(audience);
}
